var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { PureComponent } from 'react';
import { func, string, number, bool } from 'prop-types';
import { emptyFunc } from 'searchband-frontend-commons/util/func';
import { TABS_COLOR } from '../../../../data-parser/div-cards/const';
import * as CLS from './cls';

var Tab = function (_PureComponent) {
    _inherits(Tab, _PureComponent);

    function Tab() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Tab);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tab.__proto__ || Object.getPrototypeOf(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
            var _this2 = _this,
                props = _this2.props;


            props.onClick({
                index: props.index,
                action: props.action
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Tab, [{
        key: 'render',
        value: function render() {
            var props = this.props;
            var isActive = props.isActive;

            var style = {};

            if (isActive) {
                style.color = props.activeTabColor;
            }

            return React.createElement(
                'div',
                {
                    onClick: this.handleClick,
                    className: CLS.tab({ isActive: isActive })(),
                    style: style
                },
                props.title
            );
        }
    }]);

    return Tab;
}(PureComponent);

Tab.defaultProps = {
    isActive: false,
    activeTabColor: TABS_COLOR.activeTab,
    onClick: emptyFunc,
    title: '',
    index: -1
};
Tab.propTypes = {
    title: string.isRequired,
    index: number.isRequired,
    onClick: func.isRequired,
    isActive: bool,
    activeTabColor: string
};
export default Tab;